import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const mapStateToProps = (state) => {
  return {
    // OwnerListData:state.common.OwnerListData,
    // HostListData:state.common.HostListData
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
    //   getOwnerListDataAction: commonActions.getOwnerListData,
    //   getHostListDataAction: commonActions.getHostListData
    },
    dispatch
  );

const AddVehiclesStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default AddVehiclesStore;
